import Image from 'next/image';
import { useTranslation } from 'next-i18next';
import { FC, PropsWithChildren } from 'react';
import showcase from 'ylah-shared-resources/lib/images/showcase.webp';
import logo from 'ylah-shared-resources/lib/images/ylah-full-logo.svg';
import darkLogo from 'ylah-shared-resources/lib/images/ylah-full-logo-dark.svg';

import LanguageSelect from '@/components/LanguageSelect';
import classNames from '@/helpers/classNames';
import { SUPPORT_EMAIL } from '@/utils/constans';

import Link from '../../components/Link';
import styles from './TwoColumnsLayout.module.scss';

interface TwoColumnsLayoutProps {
  contentClassName?: string;
  className?: string;
  isAuthenticatedPath?: boolean;
}

const TwoColumnsLayout: FC<PropsWithChildren<TwoColumnsLayoutProps>> = ({
  children,
  contentClassName,
  className,
  isAuthenticatedPath = true,
}) => {
  const { t } = useTranslation('welcome');

  return (
    <div className={classNames([styles.container, className])}>
      <div className={styles.leftColumn}>
        <h1 className={styles.logoWrapper}>
          <Image
            src={logo}
            alt="ylah Blended Psychotherapy"
            className={styles.logo}
          />
        </h1>
        <div className={styles.showcaseWrapper}>
          <Image src={showcase} alt="" className={styles.showcase} />
        </div>
        <div className={styles.bottomSection}>
          <h3 className={styles.header}>{t('header')}</h3>
          <span className={styles.linkWrapper}>
            <p id="contact-us-description">{t('bottom-questions')}</p>
            <Link
              id="contact-us-link"
              href={`mailto:${SUPPORT_EMAIL}`}
              target="_blank"
              rel="noreferrer"
              variant="white"
              className={styles.link}
              isInline
              aria-labelledby="contact-us-link contact-us-description"
            >
              {t('bottom-contact')}
            </Link>
          </span>
        </div>
      </div>
      <div className={styles.rightColumn}>
        <div className={styles.languageSelect}>
          <span />
          <Image
            src={darkLogo}
            alt="ylah Blended Psychotherapy"
            className={styles.tabletLogo}
          />
          <LanguageSelect isAuthenticatedPath={isAuthenticatedPath} />
        </div>
        <div className={classNames([styles.content, contentClassName])}>
          {children}
        </div>
      </div>
    </div>
  );
};

export default TwoColumnsLayout;
